import type { ReactElement } from 'react';
import { Text } from '@/components/Text/Text';

const CartButtonToolTip = (): ReactElement => (
  <div className="cart-tooltip">
    <Text>Pick if you:</Text>
    <ul>
      <li>
        <img src="/src/assets/svg/tick.svg" alt="Icon" /> Know all sizes and quantity
      </li>
      <li>
        <img src="/src/assets/svg/tick.svg" alt="Icon" /> Will be paying for the order
      </li>
      <li>
        <img src="/src/assets/svg/tick.svg" alt="Icon" /> Want it shipped to one address
      </li>
    </ul>
  </div>
);

CartButtonToolTip.displayName = 'CartButtonToolTip';

export default CartButtonToolTip;
